angular.module('jv.Admin.Users')
    .controller('jvAdminUsersAgencyAddController',
        ['$scope', 'agencyUserSVC', '$timeout', '$rootScope', '$location','$window', 'breadcrumbsResolve', 'addToReqModalConfig', 'TemplateLoader',
            function($scope, agencyUserSVC, $timeout, $rootScope, $location, $window, breadcrumbsResolve, addToReqModalConfig, TemplateLoader) {
                $scope.breadcrumbsConfig = breadcrumbsResolve;
                $scope.flags.loading= false;
                $scope.result=[];
                $scope.isAddAgencyPage=true;
                $scope.field={
                    templatePlaceHolder:i18n['MESSAGE_TO_AGENCY'],
                    editMessage:false,
                    allOpenRequistion:{},
                    allClosedRequistion:{},
                    openRequistion:{},
                    closedRequistion:{},
                    templates:{},
                    agency:{},
                    sendInviteEmail:false,
                    error:{
                        required: false,
                        duplicate:false
                    }
                };

                $scope.loadField=function(){
                    angular.element($window).on('beforeunload', function(){
                        return i18n.NAV_AWAY_WARNING_MESSAGE;
                    });
                    agencyUserSVC.getAgencyUserFieldInfo(function (response) {
                        angular.extend($scope.field.agency, response);
                        if($scope.field.agency.viewFields){
                            angular.forEach($scope.field.agency.viewFields, function (efield) {
                                $scope.result[efield.EId] = efield.value;
                            });
                        }
                        if(response.agencyInviteTemplate){
                            $scope.field.templates= $scope.select2Options.setTemplates(response.agencyInviteTemplate);
                            angular.forEach($scope.field.templates, function(templt){
                                if(templt['default']){
                                    $scope.field.template= templt;
                                    $scope.result['subject']= templt.subject;
                                    $scope.result['content'] = templt.body;
                                }
                            });
                        }
                        $scope.flags.loading = false;
                            $scope.breadcrumbsConfig.links.unshift({
                                linkText: i18n['ADD_AGENCY_USER']
                        });
                    }, function (response) {
                        $scope.flags.loading = false;
                    });
                };

                $scope.loadField();

                $scope.saveAgencyUserDetails=function(){
                    var postParams={};
                    var errorFieldIds=[];
                    $scope.field.error.required=false;
                    $scope.field.error.duplicate=false;
                    $scope.field.error.invaliEmail = false;

                    $scope.flags.loading=true;
                    if($scope.field.agency.viewFields){
                        angular.forEach($scope.field.agency.viewFields, function (efield) {
                            if(efield.required){
                                if(!$scope.result[efield.EId]){
                                    $scope.field.error.required=true;
                                    errorFieldIds.push(efield.EId);
                                }else if(efield.fieldId==-3 && !$scope.isEmailValid($scope.result[efield.EId])){
                                    $scope.field.error.invaliEmail = true;
                                    errorFieldIds.push(efield.EId);
                                }
                            }
                            if($scope.result[efield.EId])
                                postParams[efield.EId] = $scope.result[efield.EId];
                        });
                    }
                    if($scope.field.sendInviteEmail && !$scope.field.error.required){
                        if(!$scope.result['subject']|| ($scope.result['subject'] && $scope.result['subject'].trim().length === 0))
                        {
                            $scope.field.error.required=true;
                            $scope.flags.loading=false;
                            return;
                        }
                        if(!$scope.result['content']|| ($scope.result['content'] && $scope.result['content'].trim().length === 0))
                        {
                            $scope.field.error.required=true;
                            $scope.flags.loading=false;
                            return;
                        }
                        postParams['subject']=$scope.result['subject'];
                        postParams['content']= $scope.result['content'];
                        /*BE expects locale to be sent to determine language for Email header/footer*/
                        postParams['locale']= $scope.field['template'].locale;
                    }
                    if($scope.field.error.invaliEmail) {
                        $scope.flags.loading = false;
                        return;
                    }
                    postParams['jobIds']=[];
                    for(var reqId in $scope.result['selectedReq']){
                        postParams['jobIds'].push(reqId);
                    }
                    if(!$scope.field.error.required){
                        agencyUserSVC.saveAgencyUser(postParams, null, function(response){
                            $scope.flags.loading=false;
                            if(response){
                                if(response.msgInfo === "SUCCESS") {
                                    $scope.isAddAgencyPage = false;
                                    $scope.removeMsgModal={};
                                    $scope.showMsg('AGENCY_USERS_SAVED');
                                    $(window).off('beforeunload');
                                    $timeout(function() {
                                        $location.path('users/agencies/AGENCY_ADDED');
                                    }, 1000);
                                }
                                else if(response.msgInfo === "EMAIL_EXIST" || response.msgInfo == 'AGENCY_EXIST' || response.msgInfo == 'EMPLOYEE_EXIST') {
                                    $scope.field.error.duplicate=true;
                                }
                                else{
                                    $scope.showMsg('UNABLE_TO_PERFORM_OPERATION', false, 'error');
                                }
                            }
                        });
                    }
                    else{
                        $scope.flags.loading=false;
                        $scope.scrollTo(errorFieldIds[0]);
                    }
                };

                $scope.isEmailValid = function(value){
                	if(!window.EMAIL_REGEX){
						throw new Error('EMAIL_REGEX is not defined');
					}
	   				var emailPattern = new RegExp(window.EMAIL_REGEX);
   					return emailPattern.test(value);
                };

                $scope.scrollTo = function (idToScroll) {
                    var top = $('#fieldId-'+idToScroll).offset().top || 220;
                    $('html,body').animate({ scrollTop: top }, 400);
                };

                $scope.modals = {
                    addToReq: {
                        show: false,
                        fetch: false
                    }
                };
                $scope.templates = TemplateLoader.register({
                    addToReq: '/jhire/modules/candidates/modals/addToReq.html'
                });

                $scope.showReqModal = function(modal) {
                    $scope.modals[modal].fetch = true;
                    agencyUserSVC.getRequisitionsFilter(function(data){
                        $scope.formTemplateConfig = addToReqModalConfig($scope.addToReqs, data);
                        TemplateLoader.load(modal).then(function(){
                           $scope.modals[modal].show = true;
                        });
                    });
                };

                $scope.hideModals = function(){
                    angular.forEach($scope.modals, function(val, key) {
                         $scope.modals[key].show = false;
                    });
                };

                $scope.clearSelectedReq = function(reqId){
                    delete $scope.result['selectedReq'][reqId];
                    delete $scope.modalData[reqId];
                };

                $scope.addToReqs = function(modalData){
                    $scope.result['selectedReq']=$scope.result['selectedReq']||{};
                    $scope.modalData = modalData.selectedReqEId;

                    for(var reqEId in modalData.selectedReqEId){
                        if(modalData.selectedReqEId[reqEId]){
                            for(var i=0; i < modalData.allItems.length; i++){
                                if(reqEId === modalData.allItems[i].EId){
                                    $scope.result.selectedReq[reqEId] = modalData.allItems[i];
                                    break;
                                }
                            }
                        }else{
                            //If user unchecks the req remove it from the list
                            delete $scope.result.selectedReq[reqEId];
                        }
                    }
                    $scope.hideModals();
                };

                $scope.$watch('field.template',function(newVal, oldVal){
                    if(newVal){
                        angular.forEach($scope.field.templates, function(templt){
                            if(templt.eid == newVal.eid){
                                $scope.field.template=templt;
                                $scope.result['subject']= templt.subject;
                                $scope.result['content'] = templt.body;
                            }
                        });
                    }else{
                        $scope.result['subject']= '';
                        $scope.result['content'] = '';
                    }
                },true);

                $scope.cancel = function(){
                    $(window).off('beforeunload');
                    $location.path('users/agencies');
                };
            }
        ]);